import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { bearing } from '@turf/bearing';
import { FeatureProperties } from '../constants';
import { getMeasurementDescription } from '../utils';

class MeasurementLineSelectState {
    dragMoveLocation: any;
    boxSelectStartLocation: any;
    boxSelectElement: any;
    boxSelecting: boolean;
    canBoxSelect: boolean;
    dragMoving: boolean;
    canDragMove: boolean;
    featureId: string;
    selectedCoordPaths: [];
    measurement: any; // DrawFeature
    feature: any;
}

const DrawSingleMeasurementLinePointSelect = {
    ...MapboxDraw.modes.direct_select
};

// Required method which will display the features
DrawSingleMeasurementLinePointSelect.toDisplayFeatures = function (
    state: MeasurementLineSelectState,
    geojson: any,
    push: (arg0: any) => void
) {
    if (state.featureId === geojson.properties.id) {
        geojson.properties.active = MapboxDraw.constants.activeStates.ACTIVE;
        push(geojson);
        MapboxDraw.lib
            .createSupplementaryPoints(geojson, {
                // map: this.map,
                midpoints: true,
                selectedPaths: state.selectedCoordPaths
            })
            .forEach(push);

        const measurementFeatureId =
            state.feature.properties.relatedFeatureIds[0];
        const lineGeoJson = state.feature.toGeoJSON();
        const measurement = this.getFeature(measurementFeatureId);
        // @ts-ignore: not in the current type
        measurement.properties.measurement =
            getMeasurementDescription(lineGeoJson);
        push(measurement.toGeoJSON());

        // Add origin (X) and end (arrow) markers
        const coords = lineGeoJson.geometry.coordinates;
        if (coords.length >= 2) {
            const start = coords[0];
            const end = coords[coords.length - 1];
            const lineBearing = bearing(start, end);

            push({
                type: 'Feature',
                properties: {
                    meta: FeatureProperties.MEASUREMENT_LINE_ORIGIN,
                    active: MapboxDraw.constants.activeStates.ACTIVE
                },
                geometry: {
                    type: 'Point',
                    coordinates: start
                }
            });

            push({
                type: 'Feature',
                properties: {
                    meta: FeatureProperties.MEASUREMENT_LINE_END,
                    bearing: lineBearing,
                    active: MapboxDraw.constants.activeStates.ACTIVE
                },
                geometry: {
                    type: 'Point',
                    coordinates: end
                }
            });
        }
    } else {
        geojson.properties.active = MapboxDraw.constants.activeStates.INACTIVE;
        push(geojson);
    }
    // @ts-ignore: not in the current type
    this.fireActionable(state);
};
export default DrawSingleMeasurementLinePointSelect;
